import classNames from 'classnames';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { WarningIcon } from '../../../atoms/icons/Warning';

import css from './style.module.scss';

type Props = {
  isLoggedIn: boolean;
  upcomingReservationCount: number;
};

const AboveReservationLimitWarning: FC<Props> = ({
  isLoggedIn,
  upcomingReservationCount,
}) => {
  const intl = useIntl();
  return (
    <div className={css.container}>
      <div className={css.warning_icon}>
        <WarningIcon />
      </div>
      <div className={classNames(css.description)}>
        <p className={css.margin_0}>
          {intl.formatMessage({
            id: 'aboveReservationLimitWarning.cannotReserveByCountLimit',
          })}
        </p>
        <p className={css.margin_0}>
          {intl.formatMessage(
            {
              id: 'aboveReservationLimitWarning.restartReservationDescription',
            },
            { reservationCount: upcomingReservationCount },
          )}
        </p>
      </div>
      {isLoggedIn && (
        <div>
          <a
            href="/u"
            className={css.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {intl.formatMessage({
              id: 'aboveReservationLimitWarning.checkCurrentReservations',
            })}
          </a>
        </div>
      )}
    </div>
  );
};

export default AboveReservationLimitWarning;
